import { useEffect, useState } from 'react';
import {
  parseTokensFromUrl,
  storeTokens,
  getStoredTokens,
  redirectToLogin,
  clearTokens,
} from './auth';
import type { AuthState } from './types';
import ChatPage from './pages/ChatPage';

function App() {
  const [authState, setAuthState] = useState<AuthState>({
    isAuthenticated: false,
    idToken: null,
    accessToken: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 1. Try to parse tokens from the URL hash (Cognito callback)
    const urlTokens = parseTokensFromUrl();
    if (urlTokens) {
      storeTokens(urlTokens.accessToken, urlTokens.idToken);
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      setAuthState({
        isAuthenticated: true,
        accessToken: urlTokens.accessToken,
        idToken: urlTokens.idToken,
      });
      setIsLoading(false);
      return;
    }

    // 2. Check sessionStorage for existing tokens
    const storedTokens = getStoredTokens();
    if (storedTokens) {
      setAuthState({
        isAuthenticated: true,
        accessToken: storedTokens.accessToken,
        idToken: storedTokens.idToken,
      });
      setIsLoading(false);
      return;
    }

    // 3. No tokens found — redirect to Cognito login (async)
    void redirectToLogin();
  }, []);

  const handleSignOut = () => {
    clearTokens();
    void redirectToLogin();
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (authState.isAuthenticated && authState.accessToken) {
    return <ChatPage accessToken={authState.accessToken} onSignOut={handleSignOut} />;
  }

  return <div>Redirecting to login...</div>;
}

export default App;
